export default {
  'login.title': 'MyStorageX',
  'login.welcome': '欢迎使用 MyStorageX',
  'login.description': 'MyStorageX 是您的云端存储助手，为您提供安全、便捷的文件存储和管理服务。随时随地，轻松访问您的所有文件。',
  'login.email.placeholder': '邮箱或用户名',
  'login.password.placeholder': '密码',
  'login.button': '登录',
  'login.loading': '登录中...',
  'login.divider': '或使用以下方式登录',
  'login.signup': '还没有账号？',
  'login.signup.link': '立即注册',
  'login.error.default': '登录失败，请稍后重试',
  'login.success': '登录成功',
  'login.forgotPassword': '忘记密码？',
  'login.forgotPassword.link': '点击这里重置',
  'signup.page.title': '注册 - MyStorageX',
  'signup.title': 'MyStorageX',
  'signup.welcome': '欢迎加入 MyStorageX',
  'signup.description': '创建您的账号，开启云端存储之旅',
  'signup.username.placeholder': '请输入用户名',
  'signup.email.placeholder': '请输入邮箱',
  'signup.password.placeholder': '请输入密码',
  'signup.confirmPassword.placeholder': '请确认密码',
  'signup.button': '注册',
  'signup.loading': '注册中...',
  'signup.login': '已有账号？',
  'signup.login.link': '立即登录',
  'signup.error.passwordMismatch': '两次输入的密码不一致',
  'signup.error.default': '注册失败，请稍后重试',
  'signup.success': '注册成功',
  'resetPassword.page.title': '重置密码 - MyStorageX',
  'resetPassword.page.description': '重置您的 MyStorageX 账户密码',
  'resetPassword.title': '重置密码',
  'resetPassword.email.placeholder': '请输入邮箱地址',
  'resetPassword.code.placeholder': '请输入验证码',
  'resetPassword.password.placeholder': '请输入新密码',
  'resetPassword.button': '重置密码',
  'resetPassword.button.loading': '重置中...',
  'resetPassword.backToLogin': '返回登录',
  'resetPassword.sendCode': '获取验证码',
  'resetPassword.sendCode.sending': '发送中...',
  'resetPassword.sendCode.retry': '{seconds}秒后重试',
  'resetPassword.error.emailRequired': '请输入邮箱地址',
  'resetPassword.error.codeRequired': '请输入验证码',
  'resetPassword.error.passwordRequired': '请输入新密码',
  'resetPassword.error.passwordLength': '密码长度必须在6-20个字符之间',
  'resetPassword.error.codeLength': '验证码长度必须为6位',
  'resetPassword.success.codeSent': '验证码已发送到您的邮箱',
  'resetPassword.success.reset': '密码重置成功',
  'resetPassword.error.sendFailed': '发送验证码失败，请稍后重试',
  'resetPassword.error.resetFailed': '重置密码失败，请稍后重试',
  'signup.username.rule.length': '用户名长度为4-10个字符',
  'signup.username.rule.format': '仅支持字母、数字、下划线和连字符',
  'signup.password.rule.length': '密码长度为6-20个字符',
  'signup.password.rule.lowercase': '包含小写字母',
  'signup.password.rule.uppercase': '包含大写字母',
  'signup.password.rule.number': '包含数字',
  'signup.password.rule.special': '包含特殊字符',
  'signup.verificationCode.placeholder': '请输入验证码',
  'signup.verificationCode.send': '获取验证码',
  'signup.verificationCode.sending': '发送中...',
  'signup.verificationCode.retry': '{seconds}秒后重试',
  'signup.verificationCode.success': '验证码已发送',
  'signup.verificationCode.error': '验证码发送失败',
  'signup.verificationCode.required': '请输入验证码',
  'signup.verificationCode.invalid': '验证码格式不正确',
  'login.verificationCode.placeholder': '请输入验证码',
  'login.verificationCode.send': '获取验证码',
  'login.verificationCode.sending': '发送中...',
  'login.verificationCode.retry': '{seconds}秒后重试',
  'login.verificationCode.success': '验证码已发送',
  'login.verificationCode.error': '验证码发送失败',
  'login.verificationCode.required': '请输入验证码',
  'login.verificationCode.invalid': '验证码格式不正确',
  'signup.error.allFieldsRequired': '请填写所有必填字段',
  'signup.error.emailInvalid': '请输入有效的邮箱地址',
  'signup.error.emailRequired': '请输入邮箱地址',
  'signup.announcement': '注册功能今日维护中！',
  'sidebar.allFiles': '全部文件',
  'sidebar.starred': '收藏夹',
  'sidebar.folders': '文件夹',
  'sidebar.trash': '回收站',
  'sidebar.decrypt': '解密工具',
  'sidebar.feedback': '提交需求',
  'sidebar.about': '关于',
  'sidebar.productLog': '产品日志',
  'filelist.column.name': '名称',
  'filelist.column.size': '大小',
  'filelist.column.updateTime': '修改时间',
  'filelist.column.recycletime': '回收时间',
  'filelist.column.actions': '操作',
  'filelist.total': '共 {total} 项',
  'filelist.action.upload': '上传文件',
  'filelist.action.newFolder': '新建文件夹',
  'filelist.action.refresh': '刷新',
  'filelist.action.search': '搜索文件',
  'filelist.action.batchDownload': '批量下载',
  'filelist.action.batchDelete': '批量删除',
  'filelist.action.download': '下载',
  'filelist.action.preview': '预览',
  'filelist.action.rename': '重命名',
  'filelist.selected': '已选择 {count} 项',
  'page.cloudDrive.title': '我的云盘',
  'page.cloudDrive.description': 'MyStorageX 云盘 - 安全存储和管理您的文件',
  'modal.newFolder.title': '新建文件夹',
  'modal.newFolder.placeholder': '请输入文件夹名称',
  
  // 文件上传模态框
  'modal.fileUpload.title': '上传文件',
  'modal.fileUpload.dragText': '将文件拖到此处，或点击上传',
  'modal.fileUpload.start': '开始上传',
  'modal.fileUpload.cancel': '取消',
  'modal.fileUpload.clear': '清空列表',
  'modal.fileUpload.encrypt': '加密选中文件',
  'modal.fileUpload.addMore': '添加更多文件',
  'modal.fileUpload.remove': '移除',
  'modal.fileUpload.error.noSelection': '请选择要移除的文件',
  'modal.fileUpload.error.noEncryption': '请选择要加密的文件',
  'modal.fileUpload.error.noClear': '没有可清空的文件',
  'modal.fileUpload.error.noStart': '没有可上传的文件',
  'modal.fileUpload.error.noCancel': '没有正在上传的文件',
  'modal.fileUpload.error.fileSize': '文件大小超出限制',
  'modal.fileUpload.error.fileType': '不支持的文件类型',
  'modal.fileUpload.error.maxCount': '超出最大文件数量限制',
  'modal.fileUpload.duplicate.title': '文件已存在',
  'modal.fileUpload.duplicate.skip': '跳过',
  'modal.fileUpload.duplicate.replace': '替换',
  'modal.fileUpload.duplicate.rename': '重命名',
  'modal.fileUpload.status.pending': '等待上传',
  'modal.fileUpload.status.uploading': '上传中',
  'modal.fileUpload.status.success': '上传成功',
  'modal.fileUpload.status.error': '上传失败',
  'modal.fileUpload.status.cancelled': '已取消',
  'modal.fileUpload.status.duplicated': '文件重复',
  'modal.fileUpload.table.filename': '文件名',
  'modal.fileUpload.table.size': '大小',
  'modal.fileUpload.table.status': '状态',
  'modal.fileUpload.table.progress': '进度',
  'modal.fileUpload.table.actions': '操作',
  'modal.fileUpload.speed': '上传速度',
  'modal.fileUpload.remainingTime': '剩余时间',
  'modal.fileUpload.total.progress': '总进度',
  'modal.fileUpload.error.message': '上传失败: {message}',
  'modal.fileUpload.confirm.clear': '确定要清空上传列表吗？',
  'modal.fileUpload.confirm.cancel': '确定要取消上传吗？',
  'modal.fileUpload.clear.mobile': '清空',
  'modal.fileUpload.encrypt.mobile': '加密',
  'modal.fileUpload.addMore.mobile': '添加',
  'productLog.title': '产品更新日志',
  
  // 解密页面
  'page.decrypt.title': 'MyStorage 文件解密工具',
  'page.decrypt.subtitle': '安全、快速、无损地解密您的文件',
  'page.decrypt.helmet.title': '文件解密工具 - MyStorage',
  'page.decrypt.helmet.description': '安全的文件解密工具 - 在浏览器中本地解密您的文件，保护您的隐私',
  
  // 文件上传区域
  'decrypt.upload.dragText': '点击或拖拽文件',
  'decrypt.upload.hint': '支持批量添加 .encrypted 文件，单个文件最大 {maxSize}',
  'decrypt.upload.button.decrypt': '解密选中文件',
  'decrypt.upload.button.clear': '清空列表',
  
  // 文件列表
  'decrypt.fileList.empty': '暂无文件，请添加需要解密的文件',
  'decrypt.fileList.column.name': '文件名',
  'decrypt.fileList.column.size': '大小',
  'decrypt.fileList.column.status': '状态',
  'decrypt.fileList.column.actions': '操作',
  'decrypt.fileList.status.pending': '等待解密',
  'decrypt.fileList.status.decrypting': '解密中',
  'decrypt.fileList.status.success': '解密成功',
  'decrypt.fileList.status.error': '解密失败',
  'decrypt.fileList.action.info': '文件信息',
  
  // 密码弹窗
  'decrypt.password.modal.title': '输入解密密码',
  'decrypt.password.modal.placeholder': '请输入解密密码',
  'decrypt.password.modal.hint': '请输入加密时设置的密码，密码将仅用于本地解密',
  
  // 安全提示弹窗
  'decrypt.security.modal.title': '安全提示',
  'decrypt.security.modal.description': '所有解密操作均在本地完成，您的密码和文件内容不会上传到服务器',
  'decrypt.security.modal.vip.title': '尊敬的会员用户，您可以：',
  'decrypt.security.modal.vip.feature1': '解密任意大小的文件',
  'decrypt.security.modal.vip.feature2': '使用智能分块解密功能，更高效且节省内存',
  'decrypt.security.modal.vip.feature3': '支持批量解密多个大文件',
  'decrypt.security.modal.free.title': '重要提示：解密过程需要在浏览器内存中进行，实际内存占用约为文件大小的3倍。',
  'decrypt.security.modal.free.feature1': '非会员用户单个文件大小限制为4GB',
  'decrypt.security.modal.free.feature2': '开通会员后可解密任意大小文件，并支持分块解密',
  'decrypt.security.modal.free.feature3': '如果出现浏览器崩溃，建议开通会员使用分块解密功能',
  
  // 文件信息弹窗
  'decrypt.fileInfo.modal.title': '文件信息',
  'decrypt.fileInfo.modal.close': '关闭',
  'decrypt.fileInfo.name': '文件名',
  'decrypt.fileInfo.size': '文件大小',
  'decrypt.fileInfo.type': '文件类型',
  'decrypt.fileInfo.lastModified': '最后修改',
  'decrypt.fileInfo.status': '状态',
  'decrypt.fileInfo.progress': '进度',
  'decrypt.fileInfo.speed': '速度',
  'decrypt.fileInfo.timeRemaining': '剩余时间',
  'decrypt.fileInfo.timeSpent': '已用时间',
  'decrypt.fileInfo.error': '错误信息',
  
  // 消息提示
  'decrypt.message.invalidFile': '请只选择带有 .encrypted 后缀的加密文件',
  'decrypt.message.duplicate': '文件 "{filename}" 已存在，已自动去重',
  'decrypt.message.oversizeTitle': '文件大小超出限制',
  'decrypt.message.oversizeContent': '以下文件超出非会员解密上限(4GB)：',
  'decrypt.message.oversizeHint': '开通会员后可解密任意大小文件，并支持分块解密功能',
  'decrypt.message.selectFile': '请选择要解密的文件',
  'decrypt.message.enterPassword': '请输入解密密码',
  'decrypt.message.decryptSuccess': '文件 {filename} 已保存到选定位置',
  'decrypt.message.saveCancel': '已取消保存文件 {filename}',
  'decrypt.message.downloadSuccess': '文件 {filename} 已保存到下载目录',
  'decrypt.message.decryptError': '文件 {filename} 解密失败: {error}',
  'decrypt.message.batchError': '批量解密失败，请重试',
  
  // 解密步骤
  'decrypt.steps.title': '解密步骤',
  'decrypt.steps.items': [
    {
      title: '选择加密文件',
      description: '选择使用 MyStorage 加密工具加密的 .encrypted 文件，支持拖拽或点击选择'
    },
    {
      title: '输入解密密码',
      description: '输入加密时设置的密码，密码将仅用于本地解密，不会被传输或存储'
    },
    {
      title: '开始解密',
      description: '点击按钮后，系统将使用 AES-256-CBC 算法在本地解密您的文件'
    },
    {
      title: '获取原始文件',
      description: '解密完成后，原始文件将自动下载，解密过程完全无损，保证文件完整性'
    }
  ],

  // 安全特性
  'security.features.title': '安全特性',
  'security.features.localDecryption.title': '本地解密保护',
  'security.features.localDecryption.description': '所有解密操作均在本地浏览器中完成，确保您的文件内容和密码绝不会上传到服务器，为您的数据安全保驾护航',
  'security.features.militaryEncryption.title': '军事级加密算法',
  'security.features.militaryEncryption.description': '采用 AES-256-CBC 加密算法，这是目前最安全的对称加密标准，可以抵御已知的所有攻击方式',
  'security.features.privacyProtection.title': '隐私数据保护',
  'security.features.privacyProtection.description': '严格的隐私保护机制，不保存任何解密密码，不记录文件内容，让您高枕无忧地使用我们的服务',
  'security.features.smartDecryption.title': '智能分块解密',
  'security.features.smartDecryption.description': '采用智能分块解密技术，显著提升解密速度，同时大幅降低内存占用，让解密更快更稳定',
  'security.features.learnMore': '了解更多',

  // 加密图表
  'security.diagram.plaintext.block1': '明文块 1',
  'security.diagram.plaintext.block2': '明文块 2',
  'security.diagram.ciphertext.block1': '密文块 1',
  'security.diagram.ciphertext.block2': '密文块 2',
  'security.diagram.key': '密钥',
  'security.diagram.aes.encryption': 'AES 加密',
  'security.diagram.xor.operation': '异或运算',
  'security.diagram.iv': '初始化向量',

  // AES 模态框
  'security.features.modal.title': 'AES-256-CBC 加密算法详解',
  'security.features.aes.what': '什么是 AES-256-CBC？',
  'security.features.aes.description': 'AES-256-CBC 是高级加密标准（Advanced Encryption Standard）的一种实现方式，其中：',
  'security.features.aes.detail.1': '一种对称加密算法，由美国国家标准与技术研究院（NIST）于2001年确立',
  'security.features.aes.detail.2': '使用256位密钥长度，提供最高级别的安全性',
  'security.features.aes.detail.3': '密码分组链接（Cipher Block Chaining）模式，提供更好的加密安全性',
  'security.features.aes.how': '工作原理',
  'security.features.aes.process': 'AES-256-CBC 的加密过程主要包含以下步骤：',
  'security.features.aes.step1': '将明文数据分割成固定大小的块（128位）',
  'security.features.aes.step2': '生成随机的初始化向量（IV）',
  'security.features.aes.step3': '使用CBC模式将前一个密文块与当前明文块进行XOR运算',
  'security.features.aes.step4': '使用256位密钥对XOR结果进行AES加密',
  'security.features.aes.example': '加密过程示例：',
  'security.features.aes.security': '安全特性',
  'security.features.aes.security.intro': 'AES-256-CBC 提供了多重安全保障：',
  'security.features.aes.security.point1': '256位密钥提供 2^256 种可能的组合，即使使用超级计算机也无法在合理时间内暴力破解',
  'security.features.aes.security.point2': 'CBC模式确保相同的明文块会产生不同的密文块，增加加密的随机性',
  'security.features.aes.security.point3': '初始化向量（IV）的使用确保即使使用相同的密钥，每次加密的结果也都不同',
  'security.features.aes.security.point4': '被广泛应用于军事、金融等高安全性要求的领域',
  'security.features.aes.diagram': 'CBC 模式加密过程动态示意图',
  'security.features.aes.why': '为什么选择 AES-256-CBC？',
  'security.features.aes.why.intro': '我们选择 AES-256-CBC 作为加密标准的原因：',
  'security.features.aes.why.point1': '经过广泛验证的安全性，至今没有实用的攻击方法',
  'security.features.aes.why.point2': '优秀的性能表现，加解密速度快',
  'security.features.aes.why.point3': '硬件加速支持，主流处理器都内置了 AES 指令集',
  'security.features.aes.why.point4': '广泛的工具支持，各种编程语言都有成熟的实现',

  // 分块解密模态框
  'security.features.chunk.title': '智能分块解密技术详解',
  'security.features.chunk.what': '什么是智能分块解密？',
  'security.features.chunk.description': '智能分块解密是一种针对大文件优化的解密技术，它将大文件分割成多个小块进行并行处理，具有以下特点：',
  'security.features.chunk.feature1.title': '动态分块',
  'security.features.chunk.feature1.desc': '根据文件大小和系统内存自动调整分块大小',
  'security.features.chunk.feature2.title': '并行处理',
  'security.features.chunk.feature2.desc': '多个数据块同时解密，充分利用多核CPU',
  'security.features.chunk.feature3.title': '内存优化',
  'security.features.chunk.feature3.desc': '通过流式处理控制内存使用，避免内存溢出',
  'security.features.chunk.feature4.title': '断点续传',
  'security.features.chunk.feature4.desc': '支持解密过程中断后继续，提高容错性',
  'security.features.chunk.how': '工作原理',
  'security.features.chunk.process': '智能分块解密的处理流程如下：',
  'security.features.chunk.step1': '文件预分析：计算最优分块大小和数量',
  'security.features.chunk.step2': '数据分块：将加密文件切分成大小相等的数据块',
  'security.features.chunk.step3': '并行解密：多个数据块同时进行解密操作',
  'security.features.chunk.step4': '流式写入：解密后的数据块按顺序写入目标文件',
  'security.features.chunk.code': '{code}',
  'security.features.chunk.performance': '性能优势',
  'security.features.chunk.performance.intro': '与传统的一次性解密相比，智能分块解密具有显著优势：',
  'security.features.chunk.performance.point1': '内存占用最高降低90%，4GB文件仅需400MB内存',
  'security.features.chunk.performance.point2': '解密速度提升3-5倍，充分利用多核CPU',
  'security.features.chunk.performance.point3': '支持超大文件（>4GB）解密，不受浏览器内存限制',
  'security.features.chunk.performance.point4': '解密过程可视化，精确显示进度和剩余时间',
  'security.features.chunk.usage': '应用场景',
  'security.features.chunk.usage.intro': '智能分块解密特别适用于以下场景：',
  'security.features.chunk.usage.point1': '大型文件（如视频、数据库备份）的解密',
  'security.features.chunk.usage.point2': '内存受限设备（如移动设备）上的解密操作',
  'security.features.chunk.usage.point3': '需要并行处理的批量文件解密',
  'security.features.chunk.usage.point4': '要求实时进度反馈的解密任务',
  'security.features.chunk.diagram': '智能分块解密流程示意图',

  // 解密图表
  'decrypt.diagram.title': '智能分块解密流程',
  'decrypt.diagram.encryptedFile': '加密文件',
  'decrypt.diagram.smartChunking': '智能分块',
  'decrypt.diagram.parallelDecryption': '并行解密',
  'decrypt.diagram.decryptedFile': '解密文件',
  'decrypt.diagram.memoryOptimization': '内存使用优化',
  'decrypt.diagram.memoryUsage': '仅占用约10%内存空间',
  'decrypt.diagram.realTimeFeedback': '实时进度反馈',
  'filelist.modal.rename.title': '重命名',
  'filelist.modal.rename.placeholder': '请输入新的名称',
  'filelist.modal.rename.ok': '确定',
  'filelist.modal.rename.cancel': '取消',
  'common.unknown': '未知',
  'common.speed': '速度',
  'common.timeSpent': '已用时间',
  'common.remaining': '剩余时间',
  'sideMenu.storageInfo.title': '存储空间',
  'sideMenu.storageInfo.usage': '已使用 {used} / 共 {total}',
  'sideMenu.storageStats.title': '存储空间统计',
  'sideMenu.storageStats.overview': '总览',
  'sideMenu.storageStats.totalFiles': '文件总数',
  'sideMenu.storageStats.totalSize': '总容量',
  'sideMenu.storageStats.fileTypes': '文件类型分布',
  'sideMenu.storageStats.providers': '服务提供商',
  'common.default': '默认',
  'common.regionCode': '地域代码',
  'common.nodeType': '节点类型',
  'common.storageUsed': '已用空间',
  'common.storageAvailable': '可用空间',
  'common.storageLimit': '总容量',
  'common.storageUsageDetail': '已用 {used} / 总容量 {total}',
  'common.defaultNode': '默认节点',
  'common.confirm': '确认',
  'common.cancel': '取消',
  'common.latency': '延迟',
  'common.retry': '重试',
  
  // 节点选择
  'cloudDrive.nodeSelect.title': '选择存储节点',
  'cloudDrive.nodeSelect.addNode': '新增存储节点',
  'cloudDrive.nodeSelect.deleteConfirm.title': '确认删除节点',
  'cloudDrive.nodeSelect.deleteConfirm.content': '确定要删除节点 "{nodeName}" 吗？删除后无法恢复！',
  'cloudDrive.nodeSelect.deleteSuccess': '节点删除成功',
  'cloudDrive.nodeSelect.deleteFailed': '删除节点失败',
  
  // 节点创建
  'cloudDrive.nodeCreate.title': '新增存储节点',
  'cloudDrive.nodeCreate.selectProvider': '选择云厂商',
  'cloudDrive.nodeCreate.nodeName': '节点名称',
  'cloudDrive.nodeCreate.nodeNamePlaceholder': '留空将使用默认名称',
  'cloudDrive.nodeCreate.nameMaxLength': '节点名称不能超过50个字符',
  'cloudDrive.nodeCreate.noProviders': '暂无可用云厂商',
  'cloudDrive.nodeCreate.pingLatency': '延迟 {value} ms',
  'cloudDrive.nodeCreate.pingTesting': '延迟测试中...',
  'cloudDrive.nodeCreate.pingFailed': '延迟测试失败',
  'cloudDrive.nodeCreate.pingUnavailable': '暂不支持延迟测试',
  'cloudDrive.nodeCreate.sortByLatency': '按延迟排序',
  'cloudDrive.nodeCreate.selectRegion': '选择地域',
  'cloudDrive.nodeCreate.selectedRegion': '已选地域',
  'cloudDrive.nodeCreate.noRegions': '暂无可用地域',
  'cloudDrive.nodeCreate.selectProviderPlaceholder': '请选择云厂商',
  'cloudDrive.nodeCreate.selectProviderRequired': '请先选择云厂商',
  'cloudDrive.nodeCreate.selectRegionRequired': '请先选择地域',
  'cloudDrive.nodeCreate.loadProvidersFailed': '获取云厂商列表失败',
  'cloudDrive.nodeCreate.loadRegionsFailed': '获取地域列表失败',
  'cloudDrive.nodeCreate.nodeType': '节点类型',
  'cloudDrive.nodeCreate.nodeType.standard': '标准存储',
  'cloudDrive.nodeCreate.nodeType.lowFreq': '低频存储',
  'cloudDrive.nodeCreate.nodeType.archive': '归档存储',
  'cloudDrive.nodeCreate.storageLimit': '存储限制',
  'cloudDrive.nodeCreate.storageLimitRequired': '请输入存储限制',
  'cloudDrive.nodeCreate.storageLimitMin': '存储限制不能小于1GB',
  'cloudDrive.nodeCreate.storageLimitPlaceholder': '请输入存储限制（GB）',
  'cloudDrive.nodeCreate.success': '存储节点创建成功',
  'cloudDrive.nodeCreate.failed': '创建存储节点失败',
  
  // 节点编辑
  'cloudDrive.nodeEdit.title': '编辑节点',
  'cloudDrive.nodeEdit.name': '节点名称',
  'cloudDrive.nodeEdit.nameRequired': '请输入节点名称',
  'cloudDrive.nodeEdit.nameMaxLength': '节点名称不能超过50个字符',
}; 